<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-user-plus"></i></div>
      <div>
        Détails apprenant n° {{data?.code}}
        <div class="page-title-subheading">Donnée de {{data?.lastname}} {{data?.firstname}}</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
    
    <div class="mb-3 card">
        <div class="card-header">
            <h6 class="card-title">Formulaire de réinscription</h6>
        </div>
        <div class="card-body">
            <form #addForm="ngForm" (ngSubmit)="store(addForm)">
                <div class="row">
                    <div class="col-12 ">
                        <div class=" form-group col-12 mb-3">
                            <label for="">Nouvelle Classe d'inscription <span class="text-danger ml-2">(*)</span></label>
                            <select class="form-control" name="classroom_id"  ngModel (change)="loadDocuments($event)">
                                <option selected disabled></option>
                                <option *ngFor="let c of classrooms" [value]="c.id" >{{c.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 col-md-6" *ngFor="let f of requiredFiles; let i=index;" >
                        <div class=" p-2 bg-light mb-2 " >
                      <div class="d-flex justify-content-between" >
                          <div>
                              <h5 class="m-1">{{f.name}} <span class="mx-1 text-danger">*</span></h5>
                              <ng-container *ngIf="!f.isSetted">
                                  <div class="form-group mb-3 col-lg-6 col-md-6 col-sm-12">
                                      <label for="">Fichier</label>
                                      <input type="file" #fileInp (change)="upload($event,i)" 
                                      accept="application/pdf">
                                  </div>
                              </ng-container>
                             
                          </div>
                          <div class="align-self-center">
                              <ng-container *ngIf="f.isSetted">
                                  <div >
                                      <div class="">
                                            <div class="d-flex justify-content-around">
                                          <i class="fa fa-eye text-info mx-1" (click)="open(content,i)" style="cursor: pointer;"></i>
                                          <i class="fa fa-trash text-danger  mx-1" (click)="removeFile(i)"  style="cursor: pointer;"></i> 
                                      </div>
                                      </div>
                                  </div>
                              </ng-container>
                      
                          </div>
                      </div>
                        </div>
                    </div>
                </div>
                <div class="text-center">
                    <button class="btn btn-sm btn-success" type="submit" [disabled]="loading" >Réinscrire <app-loading [isVisible]="loading"></app-loading></button>
                  </div>
            </form>
        </div>
    </div>


    <div class="mb-3 card">
        <div class="card-body">
        <ul class="nav nav-tabs nav-justified mb-3">
         <li class="nav-item">
        <a role="tab" class="nav-link active" id="tab-c1-0" data-bs-toggle="tab" data-bs-target="#tab-animated1-0" href="#tab-animated1-0" aria-selected="true">
        <span class="nav-text">INFORMATION SUR L'ÉLÈVE</span>
        </a>
        </li>
        <li class="nav-item">
        <a role="tab" class="nav-link" id="tab-c1-1" data-bs-toggle="tab" data-bs-target="#tab-animated1-1" href="#tab-animated1-1" aria-selected="false">
        <span class="nav-text">INFORMATION SUR LA SCOLARITÉ DE L'ENFANT</span>
        </a>
        </li>
        <li class="nav-item" >
        <a role="tab" class="nav-link" id="tab-c1-2" data-bs-toggle="tab" data-bs-target="#tab-animated1-2" href="#tab-animated1-2" aria-selected="false">
        <span class="nav-text">INFORMATION SUR LES FRÈRES ET SOEURS DE L'ENFANT</span>
        </a>
        </li>
        <li class="nav-item" >
        <a role="tab" class="nav-link" id="tab-c1-3" data-bs-toggle="tab" data-bs-target="#tab-animated1-3" href="#tab-animated1-3" aria-selected="false">
        <span class="nav-text">INFORMATION SUR LES PARENTS L'ENFANT</span>
        </a>
        </li>
        <li class="nav-item" >
        <a role="tab" class="nav-link" id="tab-c1-4" data-bs-toggle="tab" data-bs-target="#tab-animated1-4" href="#tab-animated1-4" aria-selected="false">
        <span class="nav-text">PERSONNE À CONTACTER EN CAS D'URGENCE</span>
        </a>
        </li>
       
        </ul>
        <div class="tab-content">
        <div class="tab-pane active" id="tab-animated1-0" role="tabpanel">
            <div class="row">
                <dl class="col-12 col-md-6">
                    <dt><b>Code</b></dt>
                    <dd>{{data?.code}}</dd>
                </dl>
                <dl class="col-12 col-md-6">
                    <dt><b>Nom</b></dt>
                    <dd>{{data?.lastname}}</dd>
                </dl>
                <dl class="col-12 col-md-6">
                    <dt><b>Prénom(s)</b></dt>
                    <dd>{{data?.firstname}}</dd>
                </dl>
                <dl class="col-12 col-md-6">
                    <dt><b>Date de naissance</b></dt>
                    <dd>{{data?.birthdate | date:"dd-MM-yyyy"}}</dd>
                </dl>
                <dl class="col-12 col-md-6">
                  <dt><b>Lieu de naissance</b></dt>
                  <dd>{{data?.birthplace}}</dd>
              </dl>
              <dl class="col-12 col-md-6">
                <dt><b>Adresse</b></dt>
                <dd>{{data?.address}}</dd>
            </dl>
              <dl class="col-12 col-md-6">
                <dt><b>Sexe</b></dt>
                <dd>{{data?.sex}}</dd>
            </dl>
              <dl class="col-12 col-md-6">
                <dt><b>Observation</b></dt>
                <dd>{{data?.observation}}</dd>
            </dl>
            <dl class="col-12 col-md-6">
              <dt><b>Nationalité</b></dt>
              <dd>{{data?.origin}}</dd>
          </dl>
              <dl class="col-12 col-md-6">
                <dt><b>Langue(s) parlée(s)</b></dt>
                <dd>{{data?.languages}}</dd>
            </dl>
            <dl class="col-12">
              <dt><b>Ancienne classe d'inscription</b></dt>
              <dd>{{data?.current_ay_classroom?.classroom?.name}}</dd>
          </dl>
            <dl class="col-12">
              <dt><b>Année accadémique clôturée</b></dt>
              <dd>{{data?.ins?.ay?.name}}</dd>
          </dl>
            </div>
        </div>
        <div class="tab-pane" id="tab-animated1-1" role="tabpanel">
            <table class="table table-sm">
                <thead>
                  <th>#</th>
                  <th>Année scolaire</th>
                  <th>Classe</th>
                  <th>Nom de l'établissement</th>
                  <th>Système</th>
                  <th>Pays</th>
                </thead>
                <tbody>
                  <tr *ngFor="let od of data?.ins?.old_schools; let i=index">
                    <td>{{i+1}}</td>
                    <td>{{od.academic_year}}</td>
                    <td>{{od.classroom}}</td>
                    <td>{{od.school_name}}</td>
                    <td>{{od.system}}</td>
                    <td>{{od.country}}</td>
                   
                  </tr>
                </tbody>
               </table>
        </div>
        <div  class="tab-pane" id="tab-animated1-2" role="tabpanel">
            <table class="table table-sm">
                <thead>
                  <th>#</th>
                  <th>Identité</th>
                  <th>Date de naissance</th>
                  <th>Classe</th>
                  <th>Etablissement</th>
                </thead>
                <tbody>
                  <tr *ngFor="let od of data?.parent?.families; let i=index">
                    <td>{{i+1}}</td>
                    <td>{{od.identity}}</td>
                    <td>{{od.birthdate | date:"dd-MM-yyyy"}}</td>
                    <td>{{od.classroom}}</td>
                    <td>{{od.school}}</td>
                  
                  </tr>
                </tbody>
               </table>
        </div>
        <div  class="tab-pane" id="tab-animated1-3" role="tabpanel">
            <div class="row">
                <div class="col-12 col-md-6">
                  <h6>Père</h6>
                  <div class="row">
                    <dl class="col-12 col-md-6">
                      <dt><b>Code</b></dt>
                      <dd>{{data?.parent?.code}}</dd>
                    </dl>
                    <dl class="col-12 col-md-6">
                      <dt><b>Nom</b></dt>
                      <dd>{{data?.parent?.father_lastname}}</dd>
                    </dl>
                    <dl class="col-12 col-md-6">
                      <dt><b>Prénom(s)</b></dt>
                      <dd>{{data?.parent?.father_firstname}}</dd>
                    </dl>
                    <dl class="col-12 col-md-6">
                      <dt><b>Email</b></dt>
                      <dd>{{data?.parent?.father_email}}</dd>
                    </dl>
                    <dl class="col-12 col-md-6">
                      <dt><b>Contact</b></dt>
                      <dd>{{data?.parent?.father_phone}}</dd>
                    </dl>
                    <dl class="col-12 col-md-6">
                      <dt><b>Profession</b></dt>
                      <dd>{{data?.parent?.father_job}}</dd>
                    </dl>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <h6>Mère</h6>
                  <div class="row">
                    <dl class="col-12 col-md-6">
                      <dt><b>Code</b></dt>
                      <dd>{{data?.parent?.code}}</dd>
                    </dl>
                    <dl class="col-12 col-md-6">
                      <dt><b>Nom</b></dt>
                      <dd>{{data?.parent?.mother_lastname}}</dd>
                    </dl>
                    <dl class="col-12 col-md-6">
                      <dt><b>Prénom(s)</b></dt>
                      <dd>{{data?.parent?.mother_firstname}}</dd>
                    </dl>
                    <dl class="col-12 col-md-6">
                      <dt><b>Email</b></dt>
                      <dd>{{data?.parent?.mother_email}}</dd>
                    </dl>
                    <dl class="col-12 col-md-6">
                      <dt><b>Contact</b></dt>
                      <dd>{{data?.parent?.mother_phone}}</dd>
                    </dl>
                    <dl class="col-12 col-md-6">
                      <dt><b>Profession</b></dt>
                      <dd>{{data?.parent?.mother_job}}</dd>
                    </dl>
                  </div>
                </div>
              </div>
             
        </div>
        <div  class="tab-pane" id="tab-animated1-4" role="tabpanel">
            <div class="row">
                <dl class="col-12 col-md-6">
                  <dt><b>Nom</b></dt>
                  <dd>{{data?.parent?.tutor_lastname}}</dd>
                </dl>
                <dl class="col-12 col-md-6">
                  <dt><b>Prénom(s)</b></dt>
                  <dd>{{data?.parent?.tutor_firstname}}</dd>
                </dl>
                <dl class="col-12 col-md-6">
                  <dt><b>Email</b></dt>
                  <dd>{{data?.parent?.tutor_email}}</dd>
                </dl>
                <dl class="col-12 col-md-6">
                  <dt><b>Contact</b></dt>
                  <dd>{{data?.parent?.tutor_phone}}</dd>
                </dl>
                <dl class="col-12 col-md-6">
                  <dt><b>Profession</b></dt>
                  <dd>{{data?.parent?.tutor_job}}</dd>
                </dl>
              </div>
             
        </div>
       
        </div>
        </div>
        </div>


        <ng-template #content let-offcanvas id="myCanvas">
            <div class="offcanvas-header">
                <h4 class="offcanvas-title">Visualisation du document</h4>
                <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
            </div>
            <div class="offcanvas-body">
                <object [data]="imageSrc" type="application/pdf" width="100%" height="600px"></object>
        
            </div>
        </ng-template>